



























































/// <reference types="googlemaps" />

import Vue from "vue";
import { center, zoom, paths } from "./Map Files/mapInfo";

export default Vue.extend({
  name: "WheresMyProperty",
  data: () => ({
    center: center as Record<string, number>,
    zoom: zoom as number,
    paths: paths as Array<Record<string, number>>,
    showMap: false as boolean,
    currentAddress: center as object
  }),
  computed: {
    movedCenter() {
      return this.currentAddress !== center;
    }
  },
  methods: {
    searchAddress(place: google.maps.places.PlaceResult) {
      if (place.geometry) {
        const location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
        this.currentAddress = location;
        this.center = location;
        this.zoom = 16;
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.showMap = true;
    }, 100);
  }
});
